"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaAgentListings$ = exports.AreaAgentListings$outboundSchema = exports.AreaAgentListings$inboundSchema = void 0;
exports.areaAgentListingsToJSON = areaAgentListingsToJSON;
exports.areaAgentListingsFromJSON = areaAgentListingsFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const agentattributes_js_1 = require("./agentattributes.js");
/** @internal */
exports.AreaAgentListings$inboundSchema = z.object({
    agent: z.nullable(agentattributes_js_1.AgentAttributes$inboundSchema),
});
/** @internal */
exports.AreaAgentListings$outboundSchema = z.object({
    agent: z.nullable(agentattributes_js_1.AgentAttributes$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaAgentListings$;
(function (AreaAgentListings$) {
    /** @deprecated use `AreaAgentListings$inboundSchema` instead. */
    AreaAgentListings$.inboundSchema = exports.AreaAgentListings$inboundSchema;
    /** @deprecated use `AreaAgentListings$outboundSchema` instead. */
    AreaAgentListings$.outboundSchema = exports.AreaAgentListings$outboundSchema;
})(AreaAgentListings$ || (exports.AreaAgentListings$ = AreaAgentListings$ = {}));
function areaAgentListingsToJSON(areaAgentListings) {
    return JSON.stringify(exports.AreaAgentListings$outboundSchema.parse(areaAgentListings));
}
function areaAgentListingsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaAgentListings$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaAgentListings' from JSON`);
}
//# sourceMappingURL=areaagentlistings.js.map